import { type PulseError } from '@prenuvo/pulse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { httpClient } from '@/api/http-client';
import { PatientRequest, PatientResponse } from '@/api/model';

const KEY = {
  GET_PATIENT: 'GET_PATIENT',
} as const;

const request = {
  getPatient: async ({ payload: { params } }: PatientRequest, signal?: AbortSignal) => {
    const { data } = await httpClient.get<PatientResponse>(
      `${ENDPOINTS.PATIENT}/${params.prenuvoID}`,
      { signal },
    );

    return data;
  },
};

const query = {
  useGetPatient: (
    { payload }: PatientRequest,
    config?: Partial<UseQueryOptions<PatientResponse, PulseError>>,
  ) =>
    useQuery<PatientResponse, PulseError>({
      enabled: !!payload.params.prenuvoID,
      queryFn: ({ signal }) => request.getPatient({ payload }, signal),
      queryKey: [KEY.GET_PATIENT, payload.params.prenuvoID],
      ...config,
    }),
};

export const patient = {
  KEY,
  query,
  request,
};
